import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ARow from "antd/lib/row";
import { basicStyle } from "./basicStyle";
const Row = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ _jsx(ARow, {
        ...props,
        gutter: (props === null || props === void 0 ? void 0 : props.gutter) || basicStyle.gutter,
        style: (props === null || props === void 0 ? void 0 : props.style) || basicStyle.rowStyle,
        children: children
    });
};
export { Row };
